import React, {useEffect, useState} from "react";
import "./SendManagementHistory.scss";
import {ManagementHistoryCard} from "../ManagementHistoryCard/ManagementHistoryCard";
import {courierManagerArchivedOrders_api} from "../SendManagementService";




function SendManagementHistory({data}) {

    const [history , set_history ] = useState([])
    const [status , set_status ] = useState("")
    const [search , set_search ] = useState("")

    useEffect(()=>{
        set_history(data)
    },[])

    const HandleScrollListener = async () =>{
        const doc = document.documentElement;
        let calc = doc.scrollHeight -(doc.scrollTop + doc.clientHeight)
        let cond = calc>3 || calc<-3
        if(!cond) {
            console.log("bottonnnnn");
            pageinate()
        }
    }


    useEffect(()=>{
        //handle scroll arrived to Top
        window.historyPage = 1;
        window.addEventListener('scroll',HandleScrollListener);
        return () => {
            window.removeEventListener('scroll', HandleScrollListener); // Remove Scroll Event Listener
        };
    },[])

    const pageinate = async ()=>{
        window.historyPage = window.historyPage+1;
        try{
            const response = await courierManagerArchivedOrders_api(window.historyPage,status,search);
            set_history((list)=>[...list,...response.data.results]);
        }catch (e) {
            console.log(e);
        }
    }



    const doSearch = async (word)=>{
        if(word.length===0){
            window.historyPage = 1;
            set_search("");
            try{
                const response = await courierManagerArchivedOrders_api(1,status,word);
                set_history(response.data.results);
            }catch (e) {
                console.log(e);
            }
        }

        if(word.length>2){
            window.historyPage = 1;
            set_search(word);
            try{
                const response = await courierManagerArchivedOrders_api(1,status,word);
                set_history(response.data.results);
            }catch (e) {
                console.log(e);
            }
        }
    }

    const doFilter = async (filter)=>{
        window.historyPage = 1;
            set_status(filter);
            try{
                const response = await courierManagerArchivedOrders_api(1,filter,search);
                set_history(response.data.results);
            }catch (e) {
                console.log(e);
            }
    }



    return(
        <div>
            <div className="search-box">
                <input
                    onChange={(e)=>{
                        doSearch(e.target.value)
                    }}
                    type="text" name="" id="" placeholder="جستجوی سفارشات"/>
                <select name="" id=""
                onChange={(e)=>{
                    doFilter(e.target.value)
                }}
                >
                    <option value="">همه</option>
                    <option value="20">در حال ارسال</option>
                    <option value="13">آماده ارسال</option>
                    <option value="25">تحویل شده</option>
                    <option value="15">تحویل پیک شد</option>
                    <option value="30">کنسل شده</option>
                </select>
            </div>
            {history.length>0? <>
                {history.map(item=>{
                    return(
                        <ManagementHistoryCard item={item}/>
                    )
                })}
            </>:<div className="empty-list">
                <i className="fa fa-database"></i>
                <span>سفارشی در لیست وجود ندارد</span>
            </div>
            }
        </div>
    )

}

export {SendManagementHistory};
